import { Box, Link, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import classes from "./NgwosSiteTooltip.module.css";
export default function NgwosTooltip({ tooltipInfo }) {
  const properties = tooltipInfo.info.object.properties;
  const expanded = tooltipInfo.type === "click";

  // configure title with or without site number
  const siteName = properties.name;
  const siteNumber = properties.site_number;
  const title =
    siteName && siteNumber ? `${siteName} (${siteNumber})` : siteName;

  // extract other relevant site properties to display
  const nwisLink = properties.nwis_site_url;
  const installationDate = `Installation Date: ${
    properties.installation_date || "Unknown"
  }`;
  const projects = properties.projects || [];

  return (
    <Box
      class={`${classes["tooltip"]}  ${
        tooltipInfo.type === "click" ? classes["site-clicked"] : ""
      }`}
    >
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography
          sx={{
            color: "secondary.contrastText",
            textOverflow: "ellipsis",
            width: "100%",
            textAlign: "center",
          }}
        >
          {title}
        </Typography>
      </Box>
      {!expanded && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {installationDate && (
            <Typography sx={{ color: "secondary.contrastText" }}>
              Click for more info
            </Typography>
          )}
        </Box>
      )}
      {expanded && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {installationDate && (
            <Typography sx={{ color: "secondary.contrastText" }}>
              {installationDate}
            </Typography>
          )}
          {projects.length > 0 && (
            <Typography sx={{ color: "secondary.contrastText" }}>
              Projects: {projects.map((project) => project.name).join(", ")}
            </Typography>
          )}
          {nwisLink && (
            <Link href={nwisLink} target="_blank" rel="noopener noreferrer">
              NWIS <OpenInNewIcon sx={{ fontSize: "0.8rem" }} />
            </Link>
          )}
        </Box>
      )}
    </Box>
  );
}
